export const ReturnEntityType = Object.freeze({
  Return: 'RET',
  Exchange: 'EXC',
  Purchase: 'PCH',
});

export type ReturnEntityTypes = (typeof ReturnEntityType)[keyof typeof ReturnEntityType];
